import { FC } from "react"
import { Modal } from "../../components"
import { Alert, Button, TextField } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import { Cancel, Save } from "@mui/icons-material";

interface IAddProductTypeModal{
    showModal: boolean;
    closeModal: () => void;
    updateParentState: (obj: object) => void;
    newProductType: {name: string; description: string; error: string;};
    handleAddProduct: () => {};
    savingProduct: boolean;
}

export const AddProductTypeModal: FC<IAddProductTypeModal> = ({
    showModal,
    closeModal,
    updateParentState,
    newProductType,
    handleAddProduct,
    savingProduct    
}) => {
    return(
        <Modal
         open={showModal} 
         fullWidth={false} 
         title="Add Product Type"
         onClose={closeModal}         
         >
          <div style={{display:"flex", flexDirection: 'column', gap: '1rem'}}>
        <TextField
                fullWidth
                inputProps={{
                  id: "product-type-name"
                }}
                style={{width: "20rem"}}
                placeholder="Product Type Name"
                value={newProductType.name}
                onChange={event => {
                    const value = {...newProductType, name: event.target.value}
                    updateParentState({newProductType: value});
                }}
              /> 
        <TextField
                fullWidth
                inputProps={{
                  id: "product-type-description"
                }}
                style={{width: "20rem"}}
                placeholder="Product Description"
                value={newProductType.description}
                onChange={event => {
                    const value = {
                        ...newProductType, 
                        description: event.target.value
                    };
                    updateParentState({newProductType: value});                    
                }}
              /> 
              {!!newProductType.error && <Alert severity="error">{newProductType.error}</Alert>}
              <div style={{display: "flex", gap: '0.5rem', justifyContent: "flex-end"}}>
                <Button  
                  variant="outlined" 
                  color="primary" 
                  onClick={closeModal}
                  endIcon={<Cancel />}>
                  CANCEL
                </Button>
                <LoadingButton  
                  variant="outlined" 
                  color="secondary" 
                  loading={savingProduct}
                  onClick={handleAddProduct}
                  loadingPosition="end" 
                  endIcon={<Save />}>
                  ADD
                </LoadingButton>
              </div>  
              </div>           
        </Modal>
    )
}